import "../../assets/sass/components/signUp/_signUp.scss";
import "../../assets/sass/components/signIn/_signIn.scss";

import React, {useEffect} from "react";
import { Trans, useTranslation } from "react-i18next";

import AnswerValidationService from "../../services/answerValidation/AnswerValidationService";
import answerValidationMessagesConstant from "../../services/answerValidation/answerValidationMessagesConstant";
import CONSTANT from "../../constants/Constant";
import useForm from "../../hooks/useForm";

function AfterSSOSignUp({ onSubmitUpdateSSOUserInformation, ssoRegistrationData }) {
    const { i18n } = useTranslation();

    const validateField = (name, value) => {
        let validationResult;

        switch (name) {
            case 'height_feet':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.HEIGHT_IN_FEET,
                    answerValidationMessagesConstant.HEIGHT_FEET.KEY,
                    value
                );
                return validationResult;

            case 'height_inch':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.HEIGHT_IN_INCH,
                    answerValidationMessagesConstant.HEIGHT_INCH.KEY,
                    {feet: values['height_feet'], value}
                );
                return validationResult;

            case 'dateOfBirth':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.DATE_OF_BIRTH,
                    answerValidationMessagesConstant.DATE_OF_BIRTH.KEY,
                    value
                );
                return validationResult;

            case 'Weight':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.WEIGHT,
                    answerValidationMessagesConstant.WEIGHT.KEY,
                    value
                );
                return validationResult;

            case 'Gender':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.GENDER_AS_SELECT,
                    answerValidationMessagesConstant.WEIGHT.KEY,
                    value
                );
                return validationResult;

            case 'DominantHand':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.DOMINANT_HAND_AS_SELECT,
                    answerValidationMessagesConstant.DOMINANT_HAND_AS_SELECT.KEY,
                    value
                );
                return validationResult;

            default:
                return { valid: true };
        }
    };

    const initialValuesForUpdateSSOUserInformation = {
        height_feet: 0,
        height_inch: 0,
        dateOfBirth: "",
        Weight: 0,
        Gender: "",
        DominantHand: "",
    };

    // FIX 2: Passed the correctly named `onSubmit` prop to the useForm hook.
    const { handleChange, handleBlur, handleSubmit, setFieldValue, values, errors, touched, isSubmitting } = useForm(initialValuesForUpdateSSOUserInformation, onSubmitUpdateSSOUserInformation, validateField);

    const setFieldIfValid = (field, value) => value != null && setFieldValue(field, value, false);

    const setFieldValues = (data) => {
        if (!data) return;
        const { Height, Weight, Gender, DominantHand } = data;

        if (Height) {
            const feet = Math.floor(Height / 12);
            const inches = Height % 12;
            setFieldIfValid('height_feet', feet);
            setFieldIfValid('height_inch', inches);
        }
        if (Weight) setFieldIfValid('Weight', Weight);
        if (Gender) setFieldIfValid('Gender', (Gender || '').toLowerCase());
        if (DominantHand) setFieldIfValid('DominantHand', (DominantHand || '').toLowerCase());
    };

    useEffect(() => {
        if (ssoRegistrationData) {
            setFieldValues(ssoRegistrationData);
        }
    }, [ssoRegistrationData]);

    const handleNumericInputChange = (e, fieldName) => {
        const { value } = e.target;
        // Allow only digits and an optional single decimal point
        const sanitizedValue = value.replace(/[^0-9.]/g, '');

        // Prevent multiple decimal points
        const parts = sanitizedValue.split('.');
        if (parts.length > 2) {
            setFieldValue(fieldName, parts[0] + '.' + parts.slice(1).join(''));
        } else {
            setFieldValue(fieldName, sanitizedValue);
        }
    };

    // **MODIFIED:** This function will now be called on blur to finalize the integer value
    const changeFloatToInt = (e, fieldName) => {
        const { value } = e.target;
        if (value === '' || isNaN(parseFloat(value))) { // Check if it's empty or clearly not a number
            setFieldValue(fieldName, 0); // Set to 0 or leave empty string, depending on desired behavior
            return;
        }
        const parsedValue = parseFloat(value);
        const integerValue = parseInt(parsedValue.toFixed(0));
        setFieldValue(fieldName, integerValue);
        handleBlur(e);
    }

    const handleOnKeyDown = (e) => {
        // Still useful to prevent 'e' and '+' from being typed directly
        if (e.key === 'e' || e.key === '+') {
            e.preventDefault();
        }
    }

    const shouldSignUpBtnDisabled = () => {
        return isSubmitting;
    };

    return (
        <div className="signup_signin_container flex-wrap min-height-100-vh align-content-center">
            <div>
                <div className="signup_signin_form">
                    <div>
                        <div>
                            <div className="signup_signin_form_header">
                                <p> Update Your Demographic </p>
                            </div>

                            <form className="position-relative" onSubmit={handleSubmit}>
                                <div>
                                    <div>
                                        <div className="marginBottom2rem">
                                            <div className="sign-up-name-container">
                                                <div className="signup_signin_input-container marginright">
                                                    <label className="signup_signin_input-label">Height</label>
                                                    <input
                                                        className="signin_input-field color-primary-dark-2"
                                                        type="number"
                                                        placeholder="Feet"
                                                        name="height_feet"
                                                        autoComplete="off"
                                                        onChange={(e) => handleNumericInputChange(e, 'height_feet')}
                                                        onBlur={(e) => changeFloatToInt(e, 'height_feet')}
                                                        onKeyDown={handleOnKeyDown}
                                                        value={values.height_feet}
                                                        min="1"
                                                        max="8"
                                                    />
                                                    <div></div>
                                                    {errors.height_feet && touched.height_feet && (
                                                        <div className="name-error-msg">{errors.height_feet}</div>
                                                    )}
                                                </div>
                                                <div className="signup_signin_input-container marginright">
                                                    <label className="signup_signin_input-label">&nbsp;</label>
                                                    <input
                                                        className="signin_input-field color-primary-dark-2"
                                                        type="number"
                                                        placeholder="Inch"
                                                        name="height_inch"
                                                        autoComplete="off"
                                                        onChange={(e) => handleNumericInputChange(e, 'height_inch')}
                                                        onBlur={(e) => changeFloatToInt(e, 'height_inch')}
                                                        onKeyDown={handleOnKeyDown}
                                                        value={values.height_inch}
                                                        min="0"
                                                        max="11"
                                                    />
                                                    <div></div>
                                                    {errors.height_inch && touched.height_inch && (
                                                        <div className="name-error-msg">{errors.height_inch}</div>
                                                    )}
                                                </div>
                                                <div className="signup_signin_input-container marginright">
                                                    <label className="signup_signin_input-label">&nbsp;</label>
                                                    <input
                                                        readOnly={true}
                                                        className="signin_input-field color-primary-dark-2"
                                                        type="number"
                                                        placeholder="Enter Height(Inch.)"
                                                        autoComplete="off"
                                                        value={+values.height_feet * 12 + +values.height_inch}
                                                    />
                                                    <div></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="marginBottom2rem">
                                            <div className="sign-up-name-container">
                                                <div className="signup_signin_input-container marginleft">
                                                    <label className="signup_signin_input-label">Date of birth</label>
                                                    <input
                                                        className="signin_input-field color-primary-dark-2"
                                                        type="date"
                                                        placeholder="Enter your date of birth"
                                                        name="dateOfBirth"
                                                        autoComplete="off"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.dateOfBirth}
                                                        onKeyDown={handleOnKeyDown}
                                                    />
                                                    {errors.dateOfBirth && touched.dateOfBirth && (
                                                        <div className="name-error-msg">{errors.dateOfBirth}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="marginBottom2rem">
                                            <div className="sign-up-name-container">
                                                <div className="signup_signin_input-container marginleft">
                                                    <label className="signup_signin_input-label">Weight</label>
                                                    <input
                                                        className="signin_input-field color-primary-dark-2"
                                                        type="number"
                                                        placeholder="Enter Weight(LBS)"
                                                        name="Weight"
                                                        autoComplete="off"
                                                        onChange={(e) => handleNumericInputChange(e, 'Weight')}
                                                        onBlur={(e) => changeFloatToInt(e, 'Weight')}
                                                        value={values.Weight}
                                                        onKeyDown={handleOnKeyDown}
                                                    />
                                                    {errors.Weight && touched.Weight && (
                                                        <div className="name-error-msg">{errors.Weight}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="marginBottom2rem">
                                            <div className="sign-up-name-container">
                                                <div className="signup_signin_input-container marginright">
                                                    <label className="signup_signin_input-label">Gender</label>
                                                    <select
                                                        className={`${!values.Gender ? "color-secondary" : "color-primary-dark-2"} signin_input-field `}
                                                        name="Gender"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.Gender}
                                                    >
                                                        <option value="" disabled>Select gender</option>
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option>
                                                    </select>
                                                    {errors.Gender && touched.Gender && (
                                                        <div className="name-error-msg">{errors.Gender}</div>
                                                    )}
                                                </div>

                                                <div className="signup_signin_input-container marginleft">
                                                    <label className="signup_signin_input-label">Dominant Hand</label>
                                                    <select
                                                        className={`${!values.DominantHand ? "color-secondary" : "color-primary-dark-2"} signin_input-field`}
                                                        name="DominantHand"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.DominantHand}
                                                    >
                                                        <option value="" disabled>Select dominant hand</option>
                                                        <option value="left">Left</option>
                                                        <option value="right">Right</option>
                                                    </select>
                                                    {errors.DominantHand && touched.DominantHand && (
                                                        <div className="name-error-msg">{errors.DominantHand}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="marginBottom2rem signup_signin_submit_wrapper">
                                            <button
                                                type="submit"
                                                className="signup_signin_submit"
                                                disabled={shouldSignUpBtnDisabled()}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <i className="fa fa-spinner fa-spin" />
                                                        <Trans i18nKey="common.message.info.please-wait" />
                                                    </>
                                                ) : (
                                                    i18n.t("common.form.save")
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AfterSSOSignUp;